import React, { useState } from "react";
import "./OurWorks.css";
const worksData = [
  /* ================= PVC BLINDS ================= */

  { id: 1, category: "PVC Blinds", image: "/images/pvcblinds/best-blinds-shop-coimbatore.jpg" },
  { id: 2, category: "PVC Blinds", image: "/images/pvcblinds/blackout-blinds-for-bedroom-coimbatore.jpg" },
  { id: 3, category: "PVC Blinds", image: "/images/pvcblinds/custom-blinds-for-living-room-coimbatore.jpg" },
  { id: 4, category: "PVC Blinds", image: "/images/pvcblinds/home-blinds-solution-pollachi.jpg" },
  { id: 5, category: "PVC Blinds", image: "/images/pvcblinds/luxury-window-blinds-coimbatore.jpg" },
  { id: 6, category: "PVC Blinds", image: "/images/pvcblinds/modern-window-blinds-coimbatore.jpg" },
  { id: 7, category: "PVC Blinds", image: "/images/pvcblinds/motorized-window-blinds-coimbatore.jpg" },
  { id: 8, category: "PVC Blinds", image: "/images/pvcblinds/office-window-blinds-coimbatore.jpg" },
  { id: 9, category: "PVC Blinds", image: "/images/pvcblinds/premium-blinds-installation-pollachi.jpg" },
  { id: 10, category: "PVC Blinds", image: "/images/pvcblinds/roller-blinds-for-home-coimbatore.jpg" },
  { id: 11, category: "PVC Blinds", image: "/images/pvcblinds/sun-control-blinds-pollachi.jpg" },
  { id: 12, category: "PVC Blinds", image: "/images/pvcblinds/vertical-blinds-for-office-coimbatore.jpg" },
  { id: 13, category: "PVC Blinds", image: "/images/pvcblinds/window-blinds-installation-coimbatore.jpg" },
  { id: 14, category: "PVC Blinds", image: "/images/pvcblinds/wooden-blinds-design-coimbatore.jpg" },
  { id: 15, category: "PVC Blinds", image: "/images/pvcblinds/zebra-blinds-design-pollachi.jpg" },

  // /* ================= ROLLER BLINDS ================= */

  { id: 16, category: "Roller Blinds", image: "/images/rollerblinds/affordable-roller-blinds.jpg" },
  { id: 17, category: "Roller Blinds", image: "/images/rollerblinds/best-roller-blinds-shop-coimbatore.jpg" },
  { id: 18, category: "Roller Blinds", image: "/images/rollerblinds/blackout-roller-blinds.jpg" },
  { id: 19, category: "Roller Blinds", image: "/images/rollerblinds/blackout-roller-blinds-bedroom-coimbatore.jpg" },
  { id: 20, category: "Roller Blinds", image: "/images/rollerblinds/custom-roller-blinds.jpg" },
  { id: 21, category: "Roller Blinds", image: "/images/rollerblinds/custom-roller-blinds-pollachi.jpg" },
  { id: 22, category: "Roller Blinds", image: "/images/rollerblinds/energy-saving-roller-blinds.jpg" },
  { id: 23, category: "Roller Blinds", image: "/images/rollerblinds/luxury-roller-blinds.png" },
  { id: 24, category: "Roller Blinds", image: "/images/rollerblinds/luxury-roller-blinds-design-coimbatore.jpg" },
  { id: 25, category: "Roller Blinds", image: "/images/rollerblinds/minimal-roller-blinds-design.jpg" },

  { id: 26, category: "Roller Blinds", image: "/images/rollerblinds/modern-roller-blinds-design.jpg" },
  { id: 27, category: "Roller Blinds", image: "/images/rollerblinds/modern-roller-blinds-design-coimbatore.jpg" },
  { id: 28, category: "Roller Blinds", image: "/images/rollerblinds/motorized-roller-blinds.jpg" },
  { id: 29, category: "Roller Blinds", image: "/images/rollerblinds/motorized-roller-blinds-coimbatore.jpg" },
  { id: 30, category: "Roller Blinds", image: "/images/rollerblinds/office-roller-blinds.jpg" },
  { id: 31, category: "Roller Blinds", image: "/images/rollerblinds/office-roller-blinds-coimbatore.jpg" },
  { id: 32, category: "Roller Blinds", image: "/images/rollerblinds/premium-roller-blinds-coimbatore.jpg" },
  { id: 33, category: "Roller Blinds", image: "/images/rollerblinds/printed-roller-blinds.png" },
  { id: 34, category: "Roller Blinds", image: "/images/rollerblinds/roller-blinds-bedroom.jpg" },
  { id: 35, category: "Roller Blinds", image: "/images/rollerblinds/roller-blinds-for-apartment-coimbatore.jpg" },

  { id: 36, category: "Roller Blinds", image: "/images/rollerblinds/roller-blinds-for-home-coimbatore.jpg" },
  { id: 37, category: "Roller Blinds", image: "/images/rollerblinds/roller-blinds-for-living-room-coimbatore.jpg" },
  { id: 38, category: "Roller Blinds", image: "/images/rollerblinds/roller-blinds-for-windows.jpg" },
  { id: 39, category: "Roller Blinds", image: "/images/rollerblinds/roller-blinds-installation-coimbatore.jpg" },
  { id: 40, category: "Roller Blinds", image: "/images/rollerblinds/roller-blinds-installation-pollachi.jpg" },
  { id: 41, category: "Roller Blinds", image: "/images/rollerblinds/roller-blinds-living-room.jpg" },
  { id: 42, category: "Roller Blinds", image: "/images/rollerblinds/sun-control-roller-blinds-pollachi.jpg" },
  { id: 43, category: "Roller Blinds", image: "/images/rollerblinds/sunscreen-roller-blinds.jpg" },
  { id: 44, category: "Roller Blinds", image: "/images/rollerblinds/waterproof-roller-blinds.png" },
  { id: 45, category: "Roller Blinds", image: "/images/rollerblinds/window-roller-blinds-coimbatore.jpg" },

  // /* ================= ROMAN BLINDS ================= */

  { id: 46, category: "Roman Blinds", image: "/images/romanblinds/custom-roman-blinds-pollachi.jpg" },
  { id: 47, category: "Roman Blinds", image: "/images/romanblinds/luxury-roman-blinds-design-coimbatore.jpg" },
  { id: 48, category: "Roman Blinds", image: "/images/romanblinds/premium-roman-blinds-coimbatore.jpg" },
  { id: 49, category: "Roman Blinds", image: "/images/romanblinds/roman-blinds-bedroom-coimbatore.jpg" },
  { id: 50, category: "Roman Blinds", image: "/images/romanblinds/roman-blinds-for-apartment-coimbatore.jpg" },
  { id: 51, category: "Roman Blinds", image: "/images/romanblinds/roman-blinds-for-home-coimbatore.jpg" },
  { id: 52, category: "Roman Blinds", image: "/images/romanblinds/roman-blinds-for-living-room-coimbatore.jpg" },
  { id: 53, category: "Roman Blinds", image: "/images/romanblinds/roman-blinds-for-villa-coimbatore.jpg" },
  { id: 54, category: "Roman Blinds", image: "/images/romanblinds/roman-blinds-installation-coimbatore.jpg" },
  { id: 55, category: "Roman Blinds", image: "/images/romanblinds/roman-blinds-window-treatment-coimbatore.jpg" },



  // /* ================= SOFAS ================= */
  { id: 56, category: "Sofas", image: "/images/sofa/custom-sofa-coimbatore.jpg" },
  { id: 57, category: "Sofas", image: "/images/sofa/custom-sofa-pollachi.jpg" },
  { id: 58, category: "Sofas", image: "/images/sofa/designer-sofa-coimbatore.jpg" },
  { id: 59, category: "Sofas", image: "/images/sofa/designer-sofa-pollachi.jpg" },
  { id: 60, category: "Sofas", image: "/images/sofa/home-sofa-interiors-coimbatore.jpg" },
  { id: 61, category: "Sofas", image: "/images/sofa/living-room-sofa-pollachi.jpg" },
  { id: 62, category: "Sofas", image: "/images/sofa/luxury-sofa-fabric-coimbatore.jpg" },
  { id: 63, category: "Sofas", image: "/images/sofa/luxury-sofa-fabric-pollachi.jpg" },
  { id: 64, category: "Sofas", image: "/images/sofa/modern-sofa-design-pollachi.jpg" },
  { id: 65, category: "Sofas", image: "/images/sofa/premium-sofa-fabrics-coimbatore.jpg" },
  { id: 66, category: "Sofas", image: "/images/sofa/sofa-cushion-replacement-coimbatore.jpg" },
  { id: 67, category: "Sofas", image: "/images/sofa/sofa-cushion-replacement-pollachi.jpg" },
  { id: 68, category: "Sofas", image: "/images/sofa/sofa-fabric-coimbatore.jpg" },
  { id: 69, category: "Sofas", image: "/images/sofa/sofa-fabric-shop-pollachi.jpg" },
  { id: 70, category: "Sofas", image: "/images/sofa/sofa-repair-services-coimbatore.jpg" },
  { id: 71, category: "Sofas", image: "/images/sofa/sofa-repair-services-pollachi.jpg" },
  { id: 72, category: "Sofas", image: "/images/sofa/sofa-reupholstery-coimbatore.jpg" },
  { id: 73, category: "Sofas", image: "/images/sofa/sofa-reupholstery-pollachi.jpg" },
  { id: 74, category: "Sofas", image: "/images/sofa/sofa-upholstery-services-coimbatore.jpg" },
  { id: 75, category: "Sofas", image: "/images/sofa/sofa-upholstery-services-pollachi.jpg" },


  // /* ================= Venetian Blinds ================= */
  { id: 76, category: "Venetian Blinds", image: "/images/veniciantblinds/aluminium-venetian-blinds-coimbatore.jpeg" },
  { id: 77, category: "Venetian Blinds", image: "/images/veniciantblinds/custom-venetian-blinds-pollachi.jpeg" },
  { id: 78, category: "Venetian Blinds", image: "/images/veniciantblinds/modern-venetian-blinds-coimbatore.jpeg" },
  { id: 79, category: "Venetian Blinds", image: "/images/veniciantblinds/premium-venetian-blinds-coimbatore.jpeg" },
  { id: 80, category: "Venetian Blinds", image: "/images/veniciantblinds/venetian-blinds-for-bedroom-coimbatore.jpeg" },
  { id: 81, category: "Venetian Blinds", image: "/images/veniciantblinds/venetian-blinds-for-home-coimbatore.jpeg" },
  { id: 82, category: "Venetian Blinds", image: "/images/veniciantblinds/venetian-blinds-for-living-room-coimbatore.jpeg" },
  { id: 83, category: "Venetian Blinds", image: "/images/veniciantblinds/venetian-blinds-installation-coimbatore.jpg" },
  { id: 84, category: "Venetian Blinds", image: "/images/veniciantblinds/venetian-blinds-office-coimbatore.jpeg" },
  { id: 85, category: "Venetian Blinds", image: "/images/veniciantblinds/venetian-blinds-window-treatment-coimbatore.jpeg" },
  { id: 86, category: "Venetian Blinds", image: "/images/veniciantblinds/wooden-venetian-blinds-coimbatore.jpeg" },


  // /* ================= WALLPAPERS ================= */
  { id: 87, category: "Wallpapers", image: "/images/wallpaper/3d-wallpaper-coimbatore.jpg" },
  { id: 88, category: "Wallpapers", image: "/images/wallpaper/3d-wallpaper-pollachi.jpg" },
  { id: 89, category: "Wallpapers", image: "/images/wallpaper/bedroom-wallpaper-coimbatore.jpg" },
  { id: 90, category: "Wallpapers", image: "/images/wallpaper/bedroom-wallpaper-pollachi.jpg" },
  { id: 91, category: "Wallpapers", image: "/images/wallpaper/designer-wallpaper-coimbatore.jpg" },
  { id: 92, category: "Wallpapers", image: "/images/wallpaper/designer-wallpaper-pollachi.jpg" },
  { id: 93, category: "Wallpapers", image: "/images/wallpaper/home-wallpaper-installation-coimbatore.jpg" },
  { id: 94, category: "Wallpapers", image: "/images/wallpaper/home-wallpaper-installation-pollachi.jpg" },
  { id: 95, category: "Wallpapers", image: "/images/wallpaper/living-room-wallpaper-coimbatore.jpg" },
  { id: 96, category: "Wallpapers", image: "/images/wallpaper/living-room-wallpaper-pollachi.jpg" },
  { id: 97, category: "Wallpapers", image: "/images/wallpaper/luxury-wallpaper-design-coimbatore.jpg" },
  { id: 98, category: "Wallpapers", image: "/images/wallpaper/luxury-wallpaper-design-pollachi.jpg" },
  { id: 99, category: "Wallpapers", image: "/images/wallpaper/modern-wallpaper-interiors-coimbatore.jpg" },
  { id: 100, category: "Wallpapers", image: "/images/wallpaper/modern-wallpaper-interiors-pollachi.jpg" },
  { id: 101, category: "Wallpapers", image: "/images/wallpaper/wallpaper-installation-services-coimbatore.jpg" },
  { id: 102, category: "Wallpapers", image: "/images/wallpaper/wallpaper-installation-services-pollachi.jpg" },


  // /* ================= ZEBRA BLINDS ================= */
  { id: 103, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-coimbatore.jpg" },
  { id: 104, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-installation-coimbatore.jpg" },
  { id: 105, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-for-home-coimbatore.jpg" },
  { id: 106, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-for-living-room-coimbatore.jpg" },
  { id: 107, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-for-bedroom-coimbatore.jpg" },
  { id: 108, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-for-office-coimbatore.jpg" },
  { id: 109, category: "Zebra Blinds", image: "/images/zebrablinds/modern-zebra-blinds-coimbatore.jpg" },
  { id: 110, category: "Zebra Blinds", image: "/images/zebrablinds/premium-zebra-blinds-coimbatore.jpg" },
  { id: 111, category: "Zebra Blinds", image: "/images/zebrablinds/custom-zebra-blinds-coimbatore.jpg" },
  { id: 112, category: "Zebra Blinds", image: "/images/zebrablinds/dual-layer-zebra-blinds-coimbatore.jpg" },
  { id: 113, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-window-blinds-coimbatore.jpg" },
  { id: 114, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-window-treatment-coimbatore.jpg" },
  { id: 115, category: "Zebra Blinds", image: "/images/zebrablinds/best-zebra-blinds-coimbatore.jpg" },
  { id: 116, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-interior-design-coimbatore.jpg" },
  { id: 117, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-showroom-coimbatore.jpg" },
  { id: 118, category: "Zebra Blinds", image: "/images/zebrablinds/designer-zebra-blinds-coimbatore.jpg" },
  { id: 119, category: "Zebra Blinds", image: "/images/zebrablinds/roller-style-zebra-blinds-coimbatore.jpg" },
  { id: 120, category: "Zebra Blinds", image: "/images/zebrablinds/day-night-zebra-blinds-coimbatore.jpg" },
  { id: 121, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-for-villa-coimbatore.jpg" },
  { id: 122, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-for-apartment-coimbatore.jpg" },

  { id: 123, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-pollachi.jpg" },
  { id: 124, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-installation-pollachi.jpg" },
  { id: 125, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-for-home-pollachi.jpg" },
  { id: 126, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-for-living-room-pollachi.jpg" },
  { id: 127, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-for-bedroom-pollachi.jpg" },
  { id: 128, category: "Zebra Blinds", image: "/images/zebrablinds/modern-zebra-blinds-pollachi.jpg" },
  { id: 129, category: "Zebra Blinds", image: "/images/zebrablinds/premium-zebra-blinds-pollachi.jpg" },
  { id: 130, category: "Zebra Blinds", image: "/images/zebrablinds/custom-zebra-blinds-pollachi.jpg" },
  { id: 131, category: "Zebra Blinds", image: "/images/zebrablinds/day-night-zebra-blinds-pollachi.jpg" },
  { id: 132, category: "Zebra Blinds", image: "/images/zebrablinds/designer-zebra-blinds-pollachi.jpg" },

  { id: 133, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-window-covering-coimbatore.jpg" },
  { id: 134, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-sunlight-control-coimbatore.jpg" },
  { id: 135, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-light-filtering-coimbatore.jpg" },
  { id: 136, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-privacy-solution-coimbatore.jpg" },
  { id: 137, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-home-decor-coimbatore.jpg" },
  { id: 138, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-luxury-interiors-coimbatore.jpg" },
  { id: 139, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-minimal-design-coimbatore.jpg" },
  { id: 140, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-modern-interiors-coimbatore.jpg" },
  { id: 141, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-office-interiors-coimbatore.jpg" },
  { id: 142, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-commercial-space-coimbatore.jpg" },

  { id: 143, category: "Zebra Blinds", image: "/images/zebrablinds/best-zebra-blinds-pollachi.jpg" },
  { id: 144, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-home-decor-pollachi.jpg" },
  { id: 145, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-light-control-pollachi.jpg" },
  { id: 146, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-interior-design-pollachi.jpg" },
  { id: 147, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-window-treatment-pollachi.jpg" },
  { id: 148, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-luxury-home-pollachi.jpg" },
  { id: 149, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-modern-home-pollachi.jpg" },

  { id: 150, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-residential-project-coimbatore.jpg" },
  { id: 151, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-installation-work-coimbatore.jpg" },
  { id: 152, category: "Zebra Blinds", image: "/images/zebrablinds/zebra-blinds-best-price-coimbatore.jpg" },

  // /* ================= CURTAINS ================= */

  { id: 153, category: "Curtains", image: "/images/curtains/best-curtain-designs-coimbatore.jpg" },
  { id: 154, category: "Curtains", image: "/images/curtains/blackout-curtains-coimbatore.jpg" },
  { id: 155, category: "Curtains", image: "/images/curtains/curtain-dealers-coimbatore.jpg" },
  { id: 156, category: "Curtains", image: "/images/curtains/curtain-installation-coimbatore.jpg" },
  { id: 157, category: "Curtains", image: "/images/curtains/curtain-installation-pollachi.jpg" },
  { id: 158, category: "Curtains", image: "/images/curtains/curtain-installation-services-coimbatore.jpg" },
  { id: 159, category: "Curtains", image: "/images/curtains/curtains-coimbatore.jpg" },
  { id: 160, category: "Curtains", image: "/images/curtains/curtains-for-bedroom-coimbatore.jpg" },
  { id: 161, category: "Curtains", image: "/images/curtains/curtains-for-bedroom-pollachi.jpg" },
  { id: 162, category: "Curtains", image: "/images/curtains/curtains-for-home-coimbatore.jpg" },
  { id: 163, category: "Curtains", image: "/images/curtains/curtains-for-home-pollachi.jpg" },
  { id: 164, category: "Curtains", image: "/images/curtains/curtains-for-living-room-coimbatore.jpg" },
  { id: 165, category: "Curtains", image: "/images/curtains/curtains-for-living-room-pollachi.jpg" },
  { id: 166, category: "Curtains", image: "/images/curtains/curtains-for-office-coimbatore.jpg" },
  { id: 167, category: "Curtains", image: "/images/curtains/curtains-pollachi.jpg" },
  { id: 168, category: "Curtains", image: "/images/curtains/custom-curtains-coimbatore.jpg" },
  { id: 169, category: "Curtains", image: "/images/curtains/custom-curtains-pollachi.jpg" },
  { id: 170, category: "Curtains", image: "/images/curtains/designer-curtains-coimbatore.jpg" },
  { id: 171, category: "Curtains", image: "/images/curtains/designer-curtains-pollachi.jpg" },
  { id: 172, category: "Curtains", image: "/images/curtains/eyelet-curtains-coimbatore.jpg" },
  { id: 173, category: "Curtains", image: "/images/curtains/home-curtain-designs-coimbatore.jpg" },
  { id: 174, category: "Curtains", image: "/images/curtains/luxury-curtains-coimbatore.jpg" },
  { id: 175, category: "Curtains", image: "/images/curtains/luxury-curtains-pollachi.jpg" },
  { id: 176, category: "Curtains", image: "/images/curtains/luxury-home-curtains-coimbatore.jpg" },
  { id: 177, category: "Curtains", image: "/images/curtains/modern-curtains-coimbatore.jpg" },
  { id: 178, category: "Curtains", image: "/images/curtains/modern-curtains-pollachi.jpg" },
  { id: 179, category: "Curtains", image: "/images/curtains/premium-curtains-coimbatore.jpg" },
  { id: 180, category: "Curtains", image: "/images/curtains/premium-curtains-pollachi.jpg" },
  { id: 181, category: "Curtains", image: "/images/curtains/sheer-curtains-coimbatore.jpg" },
  { id: 182, category: "Curtains", image: "/images/curtains/window-curtains-coimbatore.jpg" },

  // /* ================= MOSQUITO NET ================= */

  { id: 183, category: "Mosquito Net", image: "/images/net/mosquito-net-coimbatore.jpeg" },
  { id: 184, category: "Mosquito Net", image: "/images/net/mosquito-net-pollachi.jpg" },
  { id: 185, category: "Mosquito Net", image: "/images/net/mosquito-net-tirupur.jpeg" },
  { id: 186, category: "Mosquito Net", image: "/images/net/window-mosquito-net-coimbatore.jpeg" },
  { id: 187, category: "Mosquito Net", image: "/images/net/door-mosquito-net-pollachi.jpeg" },
  { id: 188, category: "Mosquito Net", image: "/images/net/mosquito-net-installation-tirupur.jpeg" },
  { id: 189, category: "Mosquito Net", image: "/images/net/velcro-mosquito-net-coimbatore.jpeg" },
  { id: 190, category: "Mosquito Net", image: "/images/net/sliding-mosquito-net-pollachi.jpeg" },
  { id: 191, category: "Mosquito Net", image: "/images/net/mosquito-mesh-net-tirupur.jpeg" },
  { id: 192, category: "Mosquito Net", image: "/images/net/best-mosquito-net-coimbatore.jpeg" },
  { id: 193, category: "Mosquito Net", image: "/images/net/custom-mosquito-net-pollachi.jpeg" },
  { id: 194, category: "Mosquito Net", image: "/images/net/mosquito-net-for-home-tirupur.jpeg" },
  { id: 195, category: "Mosquito Net", image: "/images/net/mosquito-net-supplier-coimbatore.jpeg" },
  { id: 196, category: "Mosquito Net", image: "/images/net/mosquito-net-dealer-pollachi.jpeg" }

];


export default function OurWorks() {
  const [activeFilter, setActiveFilter] = useState("All");
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredWorks =
    activeFilter === "All"
      ? worksData
      : worksData.filter(item => item.category === activeFilter);

  return (
    <div className="works-page">

      {/* ===== HERO ===== */}
      <section className="works-hero">
        <div className="works-hero-overlay">
          <div className="works-hero-content">
            <h1>Our Works</h1>
            <p>
              Premium Interior Design Works in Coimbatore
            </p>
          </div>
        </div>
      </section>

      {/* ===== SEO CONTENT ===== */}
      <section className="works-seo">
        <div className="works-seo-container">
          <h2>Interior Design & Décor Project Portfolio</h2>
          <p>
            <strong>The Blessing Interiors</strong> has successfully completed
            a wide range of interior décor projects in Coimbatore, delivering
            elegant, functional, and premium interior solutions for homes and
            commercial spaces. Our portfolio reflects our expertise in custom
            curtains, modern blinds, luxury wallpapers, sofa upholstery, and
            mosquito mesh installations.
          </p>
          <p>
            Each project is executed with careful material selection, precise
            measurements, and professional installation. From contemporary
            living rooms to functional office interiors, our work showcases
            timeless design, superior craftsmanship, and attention to detail.
            Browse our interior works below to explore our quality and design
            standards.
          </p>
        </div>
      </section>
      {/* ===== OUR WORKS SEO SHOWCASE ===== */}
      <section className="works-showcase">
        <div className="works-showcase-container">

          <h2 className="works-showcase-title">
            Interior Design Works That Reflect Quality & Craftsmanship
          </h2>

          {/* ROW 1 */}
          <div className="works-showcase-row">

            <div className="works-showcase-main">
              <h3>Complete Interior Décor Solutions in Coimbatore</h3>
              <p>
                At <strong>The Blessing Interiors</strong>, our interior design works
                focus on delivering functional elegance for homes and commercial
                spaces. From concept to execution, every project is handled with
                attention to detail, premium materials, and professional installation.
              </p>
              <p>
                Our completed projects include custom curtains, modern blinds, luxury
                wallpapers, sofa upholstery, and mosquito net installations across
                Coimbatore.
              </p>
            </div>

            <div className="works-showcase-side">
              <div className="works-mini-card">
                <h4>Blinds & Window Styling</h4>
                <p>
                  Roller blinds, zebra blinds, wooden blinds and vertical blinds
                  designed for privacy, light control, and modern aesthetics.
                </p>
              </div>

              <div className="works-mini-card">
                <h4>Curtains & Drapes</h4>
                <p>
                  Eyelet, pleated, blackout and sheer curtains tailored for living
                  rooms, bedrooms, and office spaces.
                </p>
              </div>
            </div>

          </div>

          {/* ROW 2 */}
          <div className="works-showcase-row reverse">

            <div className="works-showcase-side">
              <div className="works-mini-card">
                <h4>Wallpaper Installation</h4>
                <p>
                  3D wallpapers, textured wall coverings, and premium designs that
                  enhance interior depth and luxury.
                </p>
              </div>

              <div className="works-mini-card">
                <h4>Sofa Upholstery</h4>
                <p>
                  Sofa fabric replacement and re-upholstery using durable,
                  high-quality materials.
                </p>
              </div>
            </div>

            <div className="works-showcase-main">
              <h3>Residential & Commercial Interior Projects</h3>
              <p>
                We have successfully completed interior décor projects for apartments,
                villas, independent houses, offices, and retail spaces in Coimbatore.
                Each project reflects our commitment to quality workmanship and
                customer satisfaction.
              </p>
              <p>
                Our work process includes site inspection, material consultation,
                precise measurements, and clean execution — ensuring long-lasting
                interior solutions.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* ===== FILTER BUTTONS ===== */}
      <section className="works-filters">
        {["All", "PVC Blinds", "Roller Blinds", "Roman Blinds", "Venetian Blinds", "Zebra Blinds", "Curtains", "Wallpapers", "Sofas", "Mosquito Net"].map(
          item => (
            <button
              key={item}
              className={activeFilter === item ? "active" : ""}
              onClick={() => setActiveFilter(item)}
            >
              {item}
            </button>
          )
        )}
      </section>

      {/* ===== IMAGE GRID ===== */}
      <section className="works-gallery">
        <div className="works-grid">
          {filteredWorks.map(work => (
            <div
              key={work.id}
              className="works-card"
              onClick={() => setSelectedImage(work.image)}
            >
              <img src={work.image} alt={work.category} />
              <div className="works-overlay">
                <span>{work.category}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ===== IMAGE ZOOM MODAL ===== */}
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Zoomed Work" />
        </div>
      )}

    </div>
  );
}
